import navbarlogo from "../assets/women-faculty-meet/outreach_logo_black.svg";
import womenlogo from "../assets/women-faculty-meet/womenlogo.jpg";
import WomenFaculty from "../assets/women-faculty-meet/WomenFACULTY.png";
import WomenPoster from "../assets/women-faculty-meet/WomenPoster.png";
import Swati from "../assets/women-faculty-meet/Swati.jpg";
import bg from "../assets/women-faculty-meet/bg.jpg";
import bg_transparent from "../assets/women-faculty-meet/bg-transparent.png";
import shilpi from "../assets/women-faculty-meet/shilpi.jpg";
import iitd_white from "../assets/women-faculty-meet/iitd_white.png";
import outreach_logo from "../assets/women-faculty-meet/oni_logo.png";

export const SVGs = {
  navbarlogo: navbarlogo,
  womenlogo: womenlogo,
};

export const PNG = {
  WomenFaculty: WomenFaculty,
  WomenPoster: WomenPoster,
  Swati: Swati,
  bg: bg,
  bg_transparent: bg_transparent,
  shilpi: shilpi,
  iitd_white: iitd_white,
  outreach_logo: outreach_logo,
};
